import React from "react";

const Home = () => {
  return (
    <div className="container">
      <h1>Home Page</h1>
      <p>
        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quasi minus
        quas placeat ullam excepturi asperiores, eos aliquid sed doloribus iure,
        iste debitis et nulla error labore. Quae, voluptatibus a fuga alias
        labore dolorum magni! Fugit porro nam quis consequuntur corrupti eos
        repellendus deserunt neque fugiat, in dolore distinctio ducimus
        perferendis.
      </p>
    </div>
  );
};

export default Home;
